import { Ng1StateDeclaration } from '@uirouter/angularjs';

import * as Resolve from '../Resolve';
import { Roles } from '../../common';

const states: Ng1StateDeclaration[] = [
    {
        name: 'qualityAnalysis',
        url: '/qualityAnalysis',
        template: '<wt-quality-analysis></wt-quality-analysis>',
        abstract: false,
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.master, Roles.engineer, Roles.operator
            ]),
            dates: Resolve.datesResolve
        },
        params: {
            beginDate: '',
            endDate: '',
            groupGuid: '',
            searchString: '',
            selectedGroup: null
        },
        data: {
            visible: true,
            sortingOrder: 3,
            displayName: 'Data quality',
            editButtonVisibility: () => false,
            icon: 'fa-exclamation-circle',
            editRoles: [],
            ignoreHistory: true
        }
    }, {
        name: 'qualityAnalysis.overview',
        url: '/overview',
        template: '<wt-overview-quality-state class="flex-directive"></wt-overview-quality-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.master, Roles.engineer, Roles.operator
            ]),
            dates: Resolve.datesResolve
        },
        data: {
            visible: false,
            isAuthenticated: true,
            sortingOrder: 0,
            displayName: 'Overview',
            editButtonVisibility: () => false,
            icon: 'fa-exclamation-circle',
            ignoreHistory: false
        }
    }, {
        name: 'qualityAnalysis.tagsInError',
        url: '/tagsInError',
        template: '<wt-tags-in-error-state search-params="vm.searchParams" class="flex-directive"></wt-tags-in-error-state>',
        resolve: {
                auth: Resolve.authResolve,
                connected: Resolve.connectedResolve,
                roles: Resolve.rolesResolve([
                    Roles.master, Roles.engineer, Roles.operator
                ]),
                dates: Resolve.datesResolve
            },
        params: {
            errorSearch: null
        },
        data: {
            visible: false,
            isAuthenticated: true,
            sortingOrder: 0,
            displayName: 'Tags in error',
            editButtonVisibility: () => false,
            icon: 'fa-tags',
            ignoreHistory: false
        }
    }, {
        name: 'qualityAnalysis.calculated',
        url: '/calculated',
        template: '<wt-calculated-quality-state search-params="vm.searchParams" class="flex-directive"></wt-calculated-quality-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.master, Roles.engineer, Roles.operator
            ]),
            dates: Resolve.datesResolve
        },
        data: {
            visible: false,
            isAuthenticated: true,
            sortingOrder: 1,
            displayName: 'Calculated Identifiers',
            editButtonVisibility: () => false,
            icon: 'fa-calculator',
            ignoreHistory: false
        }
    }, {
        name: 'qualityAnalysis.validated',
        url: '/validated',
        template: '<wt-validated-quality-state search-params="vm.searchParams" class="flex-directive"></wt-validated-quality-state>',
        resolve: {
            auth: Resolve.authResolve,
            connected: Resolve.connectedResolve,
            roles: Resolve.rolesResolve([
                Roles.master, Roles.engineer, Roles.operator
            ]),
            dates: Resolve.datesResolve
        },
        data: {
            visible: false,
            isAuthenticated: true,
            sortingOrder: 2,
            displayName: 'Validated Identifiers',
            editButtonVisibility: () => false,
            icon: 'fa-check-square-o',
            ignoreHistory: false
        }
    }];

export default states;